import { Box, Stack } from "@mui/material";
import { useActivityLogDetailsDialog } from "../../hooks";
import { CustomeDialog } from "../CustomeDialog";
import { Loader } from "../Loader";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";

export const ActivityLogDetailsDialog = ({
  open,
  handleDialogClose,
  activityLogId,
}) => {
  const { state } = useActivityLogDetailsDialog(activityLogId);
  const title = state.activityLogDetails
    ? `${state.activityLogDetails?.date} (${state.activityLogDetails?.action} by ${state.activityLogDetails?.user})`
    : "Activity Log Details";

  return (
    <CustomeDialog
      open={open}
      handleClose={handleDialogClose}
      PaperProps={{
        sx: { width: "70vw", maxHeight: "80vh", minHeight: "50vh", p: "16px" },
      }}
      title={title}
      content={
        <Stack sx={{ height: "100%", overflowY: "auto" }}>
          <>
            {state.loading ? (
              <Box
                sx={{
                  height: "50vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Loader />
              </Box>
            ) : (
              <Box sx={{ mt: 2, flexGrow: 1, overflowY: "auto" }}>
                <ReactDiffViewer
                  oldValue={
                    JSON.stringify(
                      state.activityLogDetails?.old_data,
                      null,
                      2,
                    ) ?? ""
                  }
                  newValue={
                    JSON.stringify(
                      state.activityLogDetails?.new_data,
                      null,
                      2,
                    ) ?? ""
                  }
                  compareMethod={DiffMethod.WORDS}
                  leftTitle="Before"
                  rightTitle="After"
                />
              </Box>
            )}
          </>
        </Stack>
      }
    />
  );
};
